module.exports = __webpack_public_path__ + "img/04.55c5621a.jpg";